<template>
  <div class="container px-4 xl:px-0">
    <div class="flex flex-wrap font-sans gap-4 ">
      <p-wrapper class="py-2.5 !w-fit px-3 text-sm xs:text-base whitespace-nowrap">
        <p>Гарантия <span class="pl-2 text-gray-700">12 мес.</span></p>
      </p-wrapper>
      <p-wrapper class="py-2.5 !w-fit px-3 text-sm xs:text-base whitespace-nowrap">
        <span class="text-base">Доставка по Абхазии</span>
      </p-wrapper>
    </div>
  </div>
</template>
